import { Create, Edit, List, View, NoteSheet, JournalNoteSheet, BankReceived } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/received",
        component: List,
        name: "voucher.fd.received",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/received/create",
        component: Create,
        name: "voucher.fd.received.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/received/bank",
        component: BankReceived,
        name: "voucher.fd.received.bank",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/received/:id/edit",
        component: Edit,
        name: "voucher.fd.received.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/received/:id/view",
        component: View,
        name: "voucher.fd.received.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/received/:id/note-sheet",
        component: NoteSheet,
        name: "voucher.fd.received.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/received/:id/journal-note-sheet",
        component: JournalNoteSheet,
        name: "voucher.fd.received.journal-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
